import RootState from 'model/State/RootState';

export const selectFormOptions = (state: RootState) => state.form.formOptions;
export const selectIsFetchingFormOptions = (state: RootState) =>
  state.form.isFetchingFormOptions;
